<template>
  <div>
    <v-list three-line class="pa-0">
      <template v-for="(task, taskIndex) in filterTasks">
        <FollowUpTaskItem :key="task.id" :value="task" :hide-action="hideAction" />
        <template v-if="!hideAction">
          <v-divider v-if="taskIndex + 1 < value.length" :key="taskIndex" :inset="true"></v-divider>
        </template>
      </template>
    </v-list>

    <template v-if="countMoreItems > 0">
      <a href="javascript:void(0);" @click="$emit('onViewMore')">{{ countMoreItems }} more</a>
    </template>
  </div>
</template>

<script>
import FollowUpTaskItem from './FollowUpTaskItem.vue'
export default {
  components: {
    FollowUpTaskItem
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    hideAction: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filterTasks() {
      const tempTask = this.value

      if (this.hideAction) {
        return tempTask.slice(0, 2)
      }

      return tempTask
    },
    countMoreItems() {
      if (this.hideAction) {
        return this.value.length - 2
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Kmb/FollowUp/FollowUpTaskList.vue